import React, { useEffect, useState } from "react";
import BgWakeup from "../../images/bgWakeup.png";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import BackButton from "../bars/BackButton";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import { checkPastTime, fetchRoomNoAndPhoneNo, setRoomNoAndPhoneNo } from "../../utils/util";
import { useNavigate } from "react-router-dom";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { Box } from "@mui/material";
import { WakeUpCallSubmitButtonClick } from "../../utils/Analytics";
function WakeUp() {
  const navigate = useNavigate();
  const hotelId = localStorage.getItem("hotel-id");
  const reservationId = localStorage.getItem("reservationId");
  const appUserId = localStorage.getItem("appUserId");
  const guestId = localStorage.getItem("guestId");
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const [date, setDate] = useState(`${year}-${month}-${day}`);
  const initailDate = `${year}-${month}-${day}`;
  const [time, setTime] = useState(`${hours}:${minutes}:${seconds}`);

  const storedData = fetchRoomNoAndPhoneNo();
 
  const [roomNumber, setRoomNumber] = useState(storedData?.room);
  const [confirmRoomNumber, setConfirmRoomNumber] = useState(storedData?.room);
  const [method, setMethod] = useState("Phone Call");
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));
  var datetime = new Date(reservationData.dateOut);
  const [timeValue, setTimeValue] = useState(null) // Initialize with dayjs() wrapped in a function
  const [selectedTime, setSelectedTime] = useState(""); // State to hold the selected time

  // Extracting the date part
  var date_out =  datetime.toISOString().split("T")[0];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const submitWakeup = (e) => {
    e.preventDefault();
    setError("")
    if(!date ){
      setError("date-validation");
    }
    else if(checkPastTime(date,selectedTime) || !selectedTime){
      setError("timeCheck");
    }
    else if ((roomNumber == "")|| roomNumber !== confirmRoomNumber) {
      setError("validation");
    } 
    else {
      WakeUpCallSubmitButtonClick();
      wakeupRequest();
    }
  };


  const handleTimeChange = (newValue) => {
    setError("");
    if (newValue) {
      const formattedTime = dayjs(newValue).format('HH:mm:ss'); // Format the time to 'HH:mm:ss'
    
      console.log(newValue, formattedTime,"ddd")
      setTimeValue(newValue);
      setSelectedTime(formattedTime);
    } else {
      setSelectedTime(null); // Handle case when no valid time is selected
    }
  };

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const handleRoom = (e) => {
    setRoomNumber(e.target.value);
    setError("");
  };

  const handleConfirmRoom = (e) => {
    setConfirmRoomNumber(e.target.value);
    setError("");
  };

  const handleMethod = (e) => {
    setMethod(e.target.value);
  };

  const handleComment = (e) => {
    setComment(e.target.value);
  };

  const wakeupRequest = async (param) => {
    let data = JSON.stringify({
      hotelId,
      guestId,
      appUserId,
      reservationId,
      roomNumber,
      wakeupTime: `${date} ${selectedTime}`,
      comment,
      method,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/api/wakeupV21`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    setLoading(true);
    try {
      const response = await axios.request(config);
      console.log(response.data.success);
      if (response.data.success) {
        setError("");
        setSuccess(true);
        setRoomNoAndPhoneNo(roomNumber)
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
          navigate("../order-history")
        }, 2000);
      } else {
        setLoading(false);
        setError(response.data?.message);
      }
    } catch (error) {
      setError("axios");
      setLoading(false);
    }
  };
  return (
    <div>
      <div className="pb-28 relative">
        <div className="absolute top-3 left-3">
          <BackButton  whiteTheme={true} />
        </div>
        <img
          className="w-screen sm:h-[230px] h-[117px]"
          src={BgWakeup}
          alt="bgHotelguide"
        />
        <div className="section-wrap mx-4 mt-6 sm:mt-14">
          <div className="guestName sm:text-center text-left">Request</div>
          <div className="mt-6 text-base font-semibold">Wake up Call</div>
          <form className="flex flex-col">
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Preferred date
            </label>
            <input
              onChange={handleDate}
              value={date}
              min={initailDate}
              max={date_out}
              className="mt-2 reqInput"
              type="date"
            />
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Preferred Time
            </label>
            <Box sx={{ width: '100%' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                   <TimePicker
                    fullWidth
                    value={timeValue}
                    onChange={(val)=>handleTimeChange(val)}
                    slotProps={{ textField: { placeholder: 'Please select the time' } }}
                    sx={{
                      '& .MuiInputBase-root': {
                        borderRadius: '4px',
                        background: '#342f4f',
                        outline: 'none',
                        padding: '10px 16px',
                        border: 'none',
                        color: '#fff',
                        width: '100%',
                      },
                      '& .MuiInputBase-input': {
                        padding: '0',
                        color: 'inherit',
                        borderRadius: '4px',
                      },
                      '& .MuiSvgIcon-root': {
                        color: '#fff',
                      },
                      '&.Mui-focused .MuiInputBase-root': {
                        borderColor: 'transparent',
                        boxShadow: 'none',
                      },
                      '&:hover .MuiInputBase-root': {
                        borderColor: 'transparent',
                      },
                    }}
                  /> 
                </Box>
              </LocalizationProvider>
            </Box>
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Type of wakeup call
            </label>
            <select className="mt-2 reqInput" onChange={handleMethod}>
              <option value="Phone Call">Phone Call</option>
              <option value="Alarm">Alarm</option>
              <option value="Knock the door">Knock the door</option>
            </select>
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Room Number
            </label>
            <input
              onChange={handleRoom}
              className="mt-2 reqInput"
              type="text"
              value={roomNumber}
            />
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Confirm Room Number
            </label>
            <input
              onChange={handleConfirmRoom}
              className="mt-2 reqInput"
              type="text"
              value={confirmRoomNumber}
            />
            {/* <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Confirm Room Number
            </label>
            <input onChange={handleRoom} className="mt-2 reqInput" type="text" > */}
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Comment if any
            </label>
            <textarea
              onChange={handleComment}
              className="mt-2 reqInput"
              type="textarea"
              name=""
              id=""
            />
            <button
              disabled={loading}
              onClick={submitWakeup}
              className="bookBtn mt-10 max-w-[400px] relative"
            >
              Request
              {loading && <ButtonLoader />}
            </button>
          </form>
        </div>
        <div className="mt-10 fixed  bottom-5 left-1/2 -translate-x-1/2">
          {error == "validation" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Please enter correct room number..
              </div>
            </div>
          )}
           {error == "timeCheck" && selectedTime && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
              Wakeup call service is not available fot the chosen time.
              </div>
            </div>
          )}
           {error == "timeCheck" && !selectedTime && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Please give the preferred Time

              </div>
            </div>
          )}
          {error == "date-validation"  && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Please select a date
              </div>
            </div>
          )}
          {error != "validation" && error !="timeCheck"  && error != "" && error != "date-validation" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                {error}
              </div>
            </div>
          )}

          {success && (
            <div className="w-full flex justify-center">
              <div className="success-doc text-center mt-3">
                Successfully booked
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default WakeUp;
